var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentList.length > 0
    ? _c(
        "ul",
        { staticClass: "mt-0 mb-3" },
        [
          _vm.message !== ""
            ? _c(
                "h4",
                {
                  staticClass:
                    "gray-60 m-0 third-form-fields-contacts-list-subtitle mb-2"
                },
                [_vm._v(_vm._s(_vm.message) + " :")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.list, function(contact, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass:
                  "jc-space br b-1-gray-05 flex-row mb-2 px-3 gray-0-bkg",
                class: {
                  "b-1-primary-10 primary-05-bkg": _vm.isSelected,
                  "p-3": !_vm.isSelected
                }
              },
              [
                _vm.mode === "manual"
                  ? _c(
                      "icon-svg",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          "icon-name": "contact",
                          width: 32,
                          height: 32,
                          viewBox: "0 0 32 32"
                        }
                      },
                      [_c("icon-user")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "m-0 flex-row jc-space w-5 ellipsis" }, [
                  _c(
                    "span",
                    {
                      staticClass: "nowrap self-center flex-column ln-20 fs-3"
                    },
                    [
                      _c("span", { staticClass: "bold ellipsis" }, [
                        _vm._v(
                          _vm._s(contact.name) + " " + _vm._s(contact.forename)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.mode === "readOnly"
                        ? _c("span", { staticClass: "gray-60 ellipsis" }, [
                            _vm._v(_vm._s(contact.email))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "pl-3 gray-60 self-center wp-10 ellipsis" },
                    [_vm._v(_vm._s(contact.role))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-row jc-space ml-4" },
                  [
                    _vm.mode !== "readOnly"
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "fs-3 semibold nowrap aright hover-primary-100 flex-row ai-center",
                            attrs: {
                              "data-bot": _vm.getDatabot(
                                _vm.mode === "auto"
                                  ? "link-to-opportunity"
                                  : "edit",
                                _vm.currentStore,
                                null,
                                "contact"
                              ),
                              href: "javascript:;"
                            },
                            on: {
                              click: function($event) {
                                _vm.$emit(
                                  "edit-contact",
                                  _vm.contactIndexExists({
                                    index: index,
                                    settings: contact
                                  })
                                )
                              }
                            }
                          },
                          [
                            !_vm.isSelected
                              ? _c("i", { staticClass: "icon-plus mr-2" })
                              : _vm._e(),
                            _vm._v(
                              _vm._s(_vm.addToListWording) + "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode === "manual"
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "fs-3 semibold nowrap aright hover-primary-100",
                            attrs: {
                              "data-bot": _vm.getDatabot(
                                "cancel",
                                _vm.currentStore,
                                null,
                                "contact"
                              ),
                              href: "javascript:;"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("remove-contact", index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$l10n.__("Dissocier")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode === "readOnly" && contact.id
                      ? _c(
                          "router-link",
                          {
                            staticClass: "fs-3 semibold nowrap aright cpointer",
                            attrs: {
                              to: _vm.routerLinkParams(contact.id),
                              target: "_blank"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$l10n.__("Voir la fiche")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.mode !== "manual" && _vm.limitDisplay && !_vm.displayEnable
            ? _c(
                "a",
                {
                  staticClass: "mt-2 pointer fs-3 semibold",
                  on: {
                    click: function($event) {
                      return _vm.showMore()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$l10n.__("En afficher plus")))]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }